import request from '@/utils/request'

// 查询服务订单分页
export function pageHomeServiceOrder(data) {
  return request({
    url: '/homeservice/homeServiceOrder/page',
    method: 'post',
    data: data
  })
}

// 查询服务订单详情
export function getHomeServiceOrder(data) {
  return request({
    url: '/homeservice/homeServiceOrder/detail',
    method: 'post',
    data: data
  })
}

// 删除服务订单
export function delHomeServiceOrder(data) {
  return request({
    url: '/homeservice/homeServiceOrder/delete',
    method: 'post',
    data: data
  })
}

// 导出服务订单列表
export function exportHomeServiceOrder(data) {
  return request({
    url: '/homeservice/homeServiceOrder/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 查询师傅列表（用于分配师傅）
export function listWorker(data) {
  return request({
    url: '/homeworker/profile/list',
    method: 'get',
    params: data
  })
}

// 查询个体户列表（用于分配个体户）
export function listIndividual(data) {
  return request({
    url: '/homeworker/profile/list',
    method: 'get',
    params: data
  })
}

// 指定师傅接单
export function assignWorker(data) {
  return request({
    url: '/homeservice/homeServiceOrder/assignWorker',
    method: 'post',
    data: data
  })
}

// 查询订单加价记录列表
export function listAddPriceLog(data) {
  return request({
    url: '/homeservice/homeServiceOrder/listAddPriceLog',
    method: 'get',
    params: data
  })
}

// 查询服务订单消息列表
export function listOrderMessage(data) {
  return request({
    url: '/homeservice/homeServiceOrder/listOrderMessage',
    method: 'get',
    params: data
  })
}
